import { APP_PAGES_NAMES } from 'constants/routes';

import { isSatisfyOption } from 'shared/lib';
import type { SliceStateFromReducer } from 'shared/types';

import type { siteSettingsSlice } from './siteSettings.slice';

type TSiteSettingsSlice = SliceStateFromReducer<typeof siteSettingsSlice>;
export const selectSiteSettingsFooter = (state: TSiteSettingsSlice) => state.siteSettings.footer;
export const selectSiteSettingsHeader = (state: TSiteSettingsSlice) => {
  const { menu = [], mobileMenu = [], userMenu = [] } = state.siteSettings.header || {};

  return {
    menu,
    mobileMenu,
    userMenu,
  };
};
export const selectSiteSettingsPageName = (state: TSiteSettingsSlice) => state.siteSettings.appPageName;
export const selectIsFullDealPage = (state: TSiteSettingsSlice) =>
  state.siteSettings.appPageName === APP_PAGES_NAMES.CREDIT_FULL_DEAL;
export const selectIsRestorePage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption(
    [APP_PAGES_NAMES.NEW_FORM_RESTORE, APP_PAGES_NAMES.LOANS_OFFERS_RESTORE],
    state.siteSettings.appPageName,
  );
};

export const selectIsWaybackRestorePage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.WAYBACK_RESTORE], state.siteSettings.appPageName);
};

export const selectIsAnketaPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.NEW_FORM], state.siteSettings.appPageName);
};

export const selectIsWlAnketaPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.NEW_FORM_WL], state.siteSettings.appPageName);
};

export const selectIsOffersPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.LOANS_OFFERS], state.siteSettings.appPageName);
};

export const selectIsMarketplaceSeoPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.MARKETPLACE_SEO_LANDING], state.siteSettings.appPageName);
};

export const selectIsVitrinsPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.VITRINS], state.siteSettings.appPageName);
};

export const selectIsLoansLandingPage = (state: TSiteSettingsSlice) => {
  return isSatisfyOption([APP_PAGES_NAMES.LOANS_SEO_LANDING], state.siteSettings.appPageName);
};

export const selectIsMarketplaceEnabled = (state: TSiteSettingsSlice) => state.siteSettings.isMarketplaceEnabled;
